import moment from 'moment'

export const formatDate = (date: Date | string | undefined): string => {
  if (!date) return ''
  return moment(date).format('DD-MM-YYYY')
}

export const formatTime = (time: string | undefined): string => {
  if (!time) return ''
  return time
}

export const truncateDescription = (text: string | undefined, maxLength: number = 160): string => {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}
